export default function tagPool(tag: string): { name: string, color: string }[] {
    return tag.split(',').map((el: string) => ({
        name: el.slice(0, el.indexOf('&')),
        color: el.slice(el.indexOf('&') + 3)
    }))
}